/**
 * R0.3 Option B: when the HTTP interceptor receives 403 TENANT_WRITE_BLOCKED,
 * show an explicit snackbar so the admin understands they can stay in read-only mode.
 * Must be mounted inside SnackbarProvider.
 */

import { useEffect } from 'react';
import { useSnackbar } from '../context/SnackbarContext';
import { registerWriteBlockedMessageCallback } from '../api/http';

const WRITE_BLOCKED_MESSAGE = 'Abbonamento scaduto: puoi solo consultare i dati.';

export function WriteBlockedMessageBridge() {
  const { showMessage } = useSnackbar();

  useEffect(() => {
    registerWriteBlockedMessageCallback(() => {
      showMessage(WRITE_BLOCKED_MESSAGE, 'info');
    });
  }, [showMessage]);

  return null;
}
